"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var BonusFreeSpinRangeListEditor = /** @class */ (function (_super) {
    __extends(BonusFreeSpinRangeListEditor, _super);
    function BonusFreeSpinRangeListEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusFreeSpinRangeListEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_LB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({
                _brands: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    description: _item.description,
                    _brands: [],
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование набора диапазона фриспинов"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                brand_id: 0,
                brand_title: "",
                description: "",
                _brands: [],
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание набора диапазона фриспинов"]);
            });
        }
        this.props.listBrands.LoadData();
        this.doReSetRules();
    };
    BonusFreeSpinRangeListEditor.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_LB);
    };
    BonusFreeSpinRangeListEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false }
        });
    };
    BonusFreeSpinRangeListEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: { isError: true, errorMessage: "Поле [имя] не заполнено!" },
            });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" },
            });
            return false;
        }
        return true;
    };
    BonusFreeSpinRangeListEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Набор диапазона фриспинов изменен!");
            });
        }
    };
    BonusFreeSpinRangeListEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.state.brand_id,
                description: this.state.description,
                title: this.state.title
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Набор диапазона фриспинов добавлен!");
            });
        }
    };
    BonusFreeSpinRangeListEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusFreeSpinRangeListEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить набор диапазона фриспинов";
        }
        else {
            return "Изменить набор диапазона фриспинов";
        }
    };
    BonusFreeSpinRangeListEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) { _this.setState({ brand_id: newVal.key, brand_title: newVal.value, brand_rules: { isError: false } }); }, items: this.state._brands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            this.getDownButtons()));
    };
    BonusFreeSpinRangeListEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusFreeSpinRangeListEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 380 }, this.getMainContent()));
    };
    return BonusFreeSpinRangeListEditor;
}(React.Component));
exports.default = BonusFreeSpinRangeListEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_fsranges/ui/component/BonusFreeSpinRangesListEditor.tsx
// module id = 2495
// module chunks = 0